export default "__VITE_ASSET__PURtaAXC__"